import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import {
  OiGroupDialogData,
  OiGroupProcessDialogComponent,
} from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-pos-tfg-rewards-check-voucher',
  templateUrl: './pos-tfg-rewards-check-voucher.component.html',
  styleUrls: ['./pos-tfg-rewards-check-voucher.component.scss'],
})
export class PosTfgRewardsCheckVoucherComponent implements OnInit {
  form: FormGroup;
  stores: any[] = [];
  mode: string = 'VALIDATE';
  voucher: any;

  constructor(
    public dialogRef: MatDialogRef<PosTfgRewardsCheckVoucherComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    public dialog: MatDialog
  ) {
    this.form = fb.group({
      storeId: [null, Validators.compose([Validators.required])],
      voucherCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(`^[A-Z0-9]{15}$`),
        ]),
      ],
      salesOrderHeaderId: [null],
    });

    this.form.patchValue(data);
  }

  ngOnInit() {
    this.baseService
      .executeCommand<any>(
        'portal_oi_group_rewards_validate_voucher_config',
        this.data
      )
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores || [];
          if (this.stores.length === 1) {
            this.form.controls['storeId'].setValue(this.stores[0].storeId);
            this.form.controls['storeId'].updateValueAndValidity();
          }
        }
      });
  }

  validate() {
    const dialogData: OiGroupDialogData = {
      title: 'Validating TFG Voucher',
      function: 'portal_oi_group_rewards_validate_voucher',
      postBody: this.form.value,
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px',
    });

    ref.afterClosed().subscribe((oiResult) => {
      if (
        oiResult.responseCode === 0 &&
        oiResult.data &&
        oiResult.data.groupProcessedSuccessfully === true
      ) {
        this.baseService
          .executeCommand<any>(
            'portal_tfg_rewards_get_voucher_details_by_oi_group_id',
            oiResult.data
          )
          .subscribe((detailResponse) => {
            if (detailResponse.responseCode === 0) {
              this.mode = 'LINK';
              this.voucher = detailResponse.data;
            } else {
            }
          });
      } else {
        this.dialogRef.close(true);
      }
    });
  }

  reset() {
    this.form.controls['voucherCode'].setValue(null);
    this.form.controls['voucherCode'].updateValueAndValidity();
    this.mode = 'VALIDATE';
  }

  linkVoucher() {
    this.baseService
      .executeCommand<any>(
        'portal_sales_order_header_link_tfg_rewards_voucher',
        {
          salesOrderHeaderId: this.data.salesOrderHeaderId,
          rewardsRequestId: this.voucher.rewardsRequestId,
        }
      )
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.dialogRef.close();
        }
      });
  }
}
